import api from '../utils/axiosConfig'

export interface PostTierClaimParams {
  transaction_id: string
  user_id: string
}

export interface PostTierClaimResponse {
  status: number
  system?: string
  message: string
}

export const postTierClaim = async (
  params: PostTierClaimParams,
): Promise<PostTierClaimResponse> => {
  const res = await api.post('/bonus/claim/tier', params)
  return res.data
}
